<app-header></app-header>
<div class="container">
    <div class="guest-app-container width100" fxLayout="row">
        <div class="guest-app-child" fxLayout="column" fxLayoutGap="2%">
            <div fxLayout="row">
                <button class="online-button">
                    <ul class="custom-list">
                        <li>Guest Request Management
                        </li>
                    </ul>
                </button>
            </div>
            <h2 class="guest-app-child-heading">Seamless Service, Happy Guests</h2>
            <div *ngIf="mobile" style="align-items: center;">
                <img class="image" src="/assets/images/Guest Request Management.png" />
            </div>
            <div class="guest-app-child-text">GoFriday’s Guest Request Management simplifies hotel operations, ensuring every guest request is handled swiftly and efficiently. Delight guests, empower staff, and elevate your hotel’s service standards.
            </div>
            <div class="buttons">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
                <button class="demo-link" (click)="selectTrial()">
                    Talk to Us
                    <iconify-icon icon="material-symbols:arrow-right-alt" class="arrow-icon"></iconify-icon>
                </button>
            </div>
        </div>
        <div class="image-container" *ngIf="!mobile">
            <img class="image" src="/assets/images/Guest Request Management.png" />
        </div>
    </div>
    <div class="info-container1 width100" fxLayout="column" fxLayoutAlign="center center">
        <div fxLayout="column" class="why-choose-content-container">
            <h3 class="guest-app-child-heading2" style="padding-bottom: 5%;">
                Features of Guest Request Management
            </h3>
            <div fxLayout="row" fxLayoutGap="4%" class="why-choose-content">
                <div class="member-div" fxLayout="column" fxLayoutGap="1%" fxLayoutAlign="center center">
                    <img class="choose-image" src="/assets/images/Automated Task Scheduling.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Instant Logging
                    </h3>
                    <div class="why-choose-text">Capture requests instantly via the Guest App or front desk.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Smart Notifications.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Smart Assignments
                    </h3>
                    <div class="why-choose-text">Automatically allocate tasks to the right staff.</div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Real-Time Feedback.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Live Updates
                    </h3>
                    <div class="why-choose-text">Keep everyone—staff and guests—in the loop with real-time progress.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Multichannel Collection.png" alt="" />
                    <h3 class="why-choose-content-head">
                        SLA Compliance
                    </h3>
                    <div class="why-choose-text">Ensure requests meet service standards with built-in tracking.
                    </div>
                </div>
                <div fxLayout="column" fxLayoutGap="1%" class="member-div">
                    <img class="choose-image" src="/assets/images/Dashboard Reporting.png" alt="" />
                    <h3 class="why-choose-content-head">
                        Centralized Dashboard
                    </h3>
                    <div class="why-choose-text">Manage and monitor everything from one screen.
                    </div>
                </div>
            </div>
        </div>
        <h2 class="guest-app-child-heading2">
            Benefits
        </h2>
        <div class="benefits-container">
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">01</div>
                <h3>Delight Guests</h3>
                <p>Swift, personalized service.</p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">02</div>
                <h3>Streamline Ops</h3>
                <p>Reduce errors and save time.
                </p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">03</div>
                <h3>Empower Staff</h3>
                <p>Focus on hospitality, not admin.</p>
            </div>
            <mat-divider *ngIf="!mobile"></mat-divider>
            <div class="benefit" fxLayout="column" fxLayoutAlign="center center">
                <div class="benefit-number">04</div>
                <h3>Boost Reputation</h3>
                <p>Build guest loyalty effortlessly.</p>
            </div>
        </div>
    </div>

    <div class="info-container3 width100" fxLayout="column" fxLayoutAlign="center center">
        <div style="width: 100%;">
            <h2 class="guest-app-child-heading2" style="padding: 0% 5% 5% 16%;" *ngIf="!mobile">
                How Guest Request Management works?
            </h2>
            <div class="features-section2" fxLayout="column" *ngIf="!mobile">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5%">
                    <div class="features-image-container-left">
                        <img class="features-images" src="assets/images/Guest Request Management Works.png">
                    </div>
                    <div fxLayout="column" fxFlex="44%" fxLayoutGap="2%">
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Request Initiation
                            </div>
                            <div class="features-sub-text">
                                Guests use the app or front desk to log their requests seamlessly.
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Effortless Assignment
                            </div>
                            <div class="features-sub-text">
                                Tasks are auto-allocated to the right team member in moments, ensuring no request is
                                missed.
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Real-Time Progress
                            </div>
                            <div class="features-sub-text">
                                Updates flow to staff, managers, and guests simultaneously for maximum transparency.
                            </div>
                        </div>
                        <div fxLayout="column" fxLayoutGap="1%">
                            <div class="features-sub-heading">
                                Completion & Feedback
                            </div>
                            <div class="features-sub-text">
                                Guests are informed of task completion and can share feedback directly, ensuring
                                continuous improvement.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="center center" *ngIf="mobile">
                <div fxLayout="column" fxLayoutAlign="space-between center">
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 4% 5% 3% 5%;">
                        <h2 class="features-heading">
                            How Guest Request Management works?
                        </h2>
                    </div>
                    <div class="features-image-container-left">
                        <img class="features-images" src="assets/mobile-images/Guest Request Management Works.png">
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 15% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Request Initiation
                        </div>
                        <div class="features-sub-text">
                            Guests use the app or front desk to log their requests seamlessly.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Effortless Assignment
                        </div>
                        <div class="features-sub-text">
                            Tasks are auto-allocated to the right team member in moments, ensuring no request is missed.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Real-Time Progress
                        </div>
                        <div class="features-sub-text">
                            Updates flow to staff, managers, and guests simultaneously for maximum transparency.
                        </div>
                    </div>
                    <div fxLayout="column" fxLayoutGap="2%" style="padding: 2% 5% 5% 5%;">
                        <div class="features-sub-heading">
                            Completion & Feedback
                        </div>
                        <div class="features-sub-text">
                            Guests are informed of task completion and can share feedback directly, ensuring continuous
                            improvement.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div fxLayout="row" class="info-container4 width100" fxLayoutAlign="space-between center" *ngIf="!mobile">
        <div class="contact-image" fxFlex="45%">
            <img class="bottom-image" src="assets/images/Guest Request.png">
        </div>
        <div fxFlex="45%" fxLayout="column" fxLayoutGap="1%">
            <div>
                <h2 class="header">Let’s Elevate Guest <br> Satisfaction Together</h2>
            </div>
            <div class="info-text">
                Don’t just meet guest expectations—set new standards with GoFriday’s Guest Request Management. Simplify
                operations, delight guests, and drive lasting success.
                Ready to transform your hotel guest experience?
            </div>
            <div style="margin-top: 3%;">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
            </div>
        </div>
    </div>

    <div fxLayout="column" class="info-container4 width100" fxLayoutAlign="center center" *ngIf="mobile">
        <div>
            <div>
                <h2 class="header">Let’s Elevate Guest Satisfaction Together</h2>
            </div>
            <div class="contact-image" *ngIf="mobile" style="text-align: center;">
                <img src="assets/mobile-images/Guest Request.png">
            </div>
            <div class="info-text">
                Don’t just meet guest expectations—set new standards with GoFriday’s Guest Request Management. Simplify
                operations, delight guests, and drive lasting success.
                Ready to transform your hotel guest experience?
            </div>
            <div style="margin-top: 3%;text-align: center;">
                <button class="book-btn" (click)="openCalendlyPopup()">
                    Book A Demo Today
                </button>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>